module.exports = __webpack_public_path__ + "img/copyright.fa99fde4.svg";